import axios from "axios";
import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { canEditOrDelete } from "../utils/Utils";
import { producaov2 } from "../services/apis";

export default function RouteWrapper({
  component: Component,
  isPrivate,
  notAdmin,
  ...rest
}) {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (notAdmin) {
      return;
    }

    const loadAuth = async () => {
      const oauthInLocalStorage = localStorage.getItem("oauth_token");


      let isAdmin = false;

      try {
        const res = await producaov2.post(
          "admin/auth",
          {},
          {
            headers: {
              access_token: `voitto-token ${oauthInLocalStorage}`,
            },
          }
        );
        isAdmin = res.data.action == "success";
      } catch (err) {
        console.error("Erro", err);
      }

      if (!isAdmin) {
        localStorage.setItem("redirect", window.location.pathname);
        window.location.href = "/login";
        return;
      }
      try {
        const pessoa = await producaov2.get("/perfil", {
          headers: {
            access_token: `voitto-token ${oauthInLocalStorage}`,
          },
        });
        if (
          pessoa.data.email &&
          !canEditOrDelete(pessoa.data.email, rest.computedMatch.path)
        ) {
          window.location.href = "/admin";
        }
      } catch (err) {
        console.error("Erro", err);
      }
      setAllowed(true);
    };

    loadAuth();
  }, [notAdmin]);

  if (!allowed && !notAdmin) {
    return null;
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />;
}
